import { render, staticRenderFns } from "./Tscore.vue?vue&type=template&id=df5fb4b6&scoped=true"
import script from "./Tscore.vue?vue&type=script&lang=js"
export * from "./Tscore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5fb4b6",
  null
  
)

export default component.exports